<template>
  <el-dialog width="45%" class="dialog" :title="getTitle()" :visible="visible" @close="close">
    <el-form ref="ruleForm" label-position="left" :rules="rules" :model="dialogForm" label-width="120px">
      <el-form-item label="区域选择：" prop="addressKeys">
        <div class="tree">
          <el-tree
            ref="tree"
            :data="treeData"
            show-checkbox
            node-key="keyStr"
            :default-expanded-keys="expandedKeys"
            :default-checked-keys="checkedKeys"
            @check-change="checkChange"
            :props="{
                  children: 'areaManagementChildVOS',
                  label: 'label'
                }">
          </el-tree>
        </div>
      </el-form-item>
      <el-form-item label="生效范围" prop="userType">
        <el-select v-model="dialogForm.userType" placeholder="请选择" clearable style="width:100%" @change="userTypeChangeFun">
          <el-option v-for="item in effectiveScope" :key="item.value" :label="item.label" :value="item.value" style="width:100%" >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回收品类：" prop="spid">
        <el-select v-model="dialogForm.spid" placeholder="请选择" clearable style="width:100%" @change="handleSpidChange" :disabled="!dialogForm.userType">
          <el-option v-for="item in dlList" :key="item.spid" :label="item.spmc" :value="item.spid"
                     style="width:100%">
          </el-option>
        </el-select>
      </el-form-item>
      
        <el-form-item prop="xlid" v-if="xlList.length > 0">
          <el-select v-model="dialogForm.xlid" placeholder="请选择" clearable style="width:100%"
                     :disabled="!dialogForm.spid" @change="()=>{ dialogForm.xhid = '';getSpModel()}">
            <el-option v-for="item in xlList" :key="item.xlid" :label="item.xlmc" :value="item.xlid"
                       style="width:100%">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="xhid" v-if="modelList.length > 0">
          <el-select v-model="dialogForm.xhid" placeholder="请选择" clearable style="width:100%"
                     :disabled="!dialogForm.xlid">
            <el-option v-for="item in modelList" :key="item.xhid" :label="item.xhmc" :value="item.xhid"
                       style="width:100%">
            </el-option>
          </el-select>
        </el-form-item>

      <el-form-item label="回收价格：" prop="recyclingPrice">
        <el-input-number v-model="dialogForm.recyclingPrice" :min="1" :max="999999"></el-input-number>
      </el-form-item>
      
      <el-form-item label="合作方名称：" prop="partnerId">
        <el-select v-model="dialogForm.partnerId" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="item in managementOptions" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"
                     style="width:100%">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="addArea('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'partnerManagement',
  props: {
    visible: {
      type: Boolean,
    },
    editId: {
      type: Number | String,
    }
  },
  data() {
    return {
      dialogForm: {
        spid: '',
        xlid: '',
        xhid: '',
        addressKeys: [],
        recyclingPrice: '',//回收价格
        partnerId: '',
        userType: ''
      },
      rules: {
        addressKeys: [
          {type:'array', required: true, message: '请选择区域', trigger: 'change'},
        ],
        spid: [
          {required: true, message: '请选择回收品类', trigger: 'change'},
        ],
        recyclingPrice: [
          {required: true, message: '请填写价格', trigger: 'change'},
        ],
        partnerId: [
          {required: true, message: '请填写合作方名称', trigger: 'change'},
        ],
        userType: [
          {required: true, message: '请选择生效范围', trigger: 'change'},
        ],
        xlid: [
          {required: true, message: '请选择', trigger: 'change'},
        ],
        xhid: [
          {required: true, message: '请选择', trigger: 'change'},
        ]
      },
      dlList: [],//大类
      xlList: [],//小类
      modelList: [],//模型
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      btnLoading: false,
      managementOptions: [],
      effectiveScope: [
        {value: 1, label: '用户订单'},
        {value: 2, label: '批量订单'}
      ]
    }
  },
  watch: {
    "dialogForm.spid"(value) {
      if (value) {
        this.getSpXiaolei();
      }
      console.log(value);
    },
    "dialogForm.xlid"(value) {
      if (value) {
        this.getSpModel();
        // 动态更新 xhid 验证规则
        this.rules.xhid = [{ required: true, message: '请选择', trigger: 'change' }];
      } else {
        this.rules.xhid = [{ required: false, message: '请选择', trigger: 'change' }];
      }
    },
    "dialogForm.userType"(value) {
      this.updateDynamicRules(value);
    }
  },
  methods: {
    getTitle(){
      return this.editId ? '编辑新区域':'创建新区域' 
    },
    checkChange() {
      this.dialogForm.addressKeys = this.$refs.tree.getCheckedKeys()
    },
    close() {
      this.$emit('update:visible', false)
    },
    addArea(formName) {
      let url = '/autoapp-default-server-recovery/api/area-management/save'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          let info = this.dialogForm
          let arr = this.treeFilter(this.treeData, function (node) {
            return info.addressKeys.includes(node.keyStr)
          })
          let spInfo = this.dlList.find(item => item.spid == this.dialogForm.spid)
          let xlInfo = this.xlList.find(item => item.xlid == this.dialogForm.xlid)
          let xhInfo = this.modelList.find(item => item.xhid == this.dialogForm.xhid)

          const partnerNameObj = this.managementOptions.find((item) => item.partnershipId == this.dialogForm.partnerId)
          const partnerName = partnerNameObj ? partnerNameObj.partnerName : ''
          let params = {
            tblAreaManagement: {
              ...this.dialogForm,
              partnerName,
              spmc: spInfo ? spInfo.spmc :'',
              xlmc: xlInfo ? xlInfo.xlmc :'',
              xhmc: xhInfo ? xhInfo.xhmc :''
            },
            areaManagementChildVOS: arr
          }
          console.log('params', params)
          this.HttpService.post(url, params).then(res => {
            if (res.statusCode === 200){
              this.$message.success('操作成功')
              this.close()
              this.$emit('onClose')
            }else{
              this.$message.error(res.message)
            }
            this.btnLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    treeFilter(tree, func) {
      return tree.map(node => ({...node})).filter(node => {
        node.areaManagementChildVOS = node.areaManagementChildVOS && this.treeFilter(node.areaManagementChildVOS, func)
        return func(node) || (node.areaManagementChildVOS && node.areaManagementChildVOS.length)
      })
    },
    //遍历树结构
    treeForeach(tree, func) {
      tree.forEach(data => {
        func(data)
        data.areaManagementChildVOS && this.treeForeach(data.areaManagementChildVOS, func) // 遍历子树
      })
    },
    getTblSplbDalei() {
      let userType = this.dialogForm.userType === 1 ? 1 : 3
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=${userType}`).then(res => {
        if (res.statusCode === 200) {
          this.dlList = res.data
        }
      })
    },
    //获取小类
    getSpXiaolei() {
      if(this.dialogForm.userType==1){
        return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-splb-xiaolei/getTblSplbXiaolei?flag=1&spid=${this.dialogForm.spid}`).then(res => {
          if (res.statusCode === 200) {
            this.xlList = res.data
          }
        })
      }else if(this.dialogForm.userType==2){
        return this.HttpService.get(`/autoapp-default-server-recovery/api/tblSplbYxypSubcategory/getBatchSubCategoryBySpid?isValid=1&spid=${this.dialogForm.spid}`).then(res => {
          if (res.statusCode === 200) {
            this.xlList = res.data
          }
        })
      }
      this.getSpModel()
      return this.xlList = []
    },
    //获取机型
    getSpModel() {
      if(this.dialogForm.userType==1){
        let params = {
          flag: 1,
          id: '',
          spid: this.dialogForm.spid,
          xlid: this.dialogForm.xlid
        }
        return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-splb-jixin/getTblSplbJixin?flag=${params.flag}&id=&spid=${params.spid}&xlid=${params.xlid}`).then(res => {
          if (res.statusCode === 200) {
            this.modelList = res.data
            if(this.modelList.length && !this.modelList[0].xhno){
               this.modelList = []
            }
          }
        })
      }else if(this.dialogForm.userType==2){
        let params = {
          flag: 1,
          spid: this.dialogForm.spid,
          xlid: this.dialogForm.xlid
        }
        return this.HttpService.get(`/autoapp-default-server-recovery/api/tblSplbYxypSubcategory/getBatchSpecificationByXlid?isValid=1&xlid=${this.dialogForm.xlid}`, params).then(res => {
          if (res.statusCode === 200) {
            this.modelList = res.data
            if(this.modelList.length && !this.modelList[0].xhid){
               this.modelList = []
            }
          }
        })
      }
      return this.modelList = []
    },
    loadAddressList() {
      this.HttpService.get('/autoapp-default-server-recovery/api/tbl-province/treeHierarchy').then(res => {
        if (res.statusCode === 200) {
          this.treeData = res.data
          if (this.editId) {
            this.loadInfo()
          }
        }
      })
    },
    loadInfo() {
      this.HttpService.get(`/autoapp-default-server-recovery/api/area-management/getOne?regionId=${this.editId}`).then(res => {
        if (res.statusCode === 200) {
          this.dialogForm = res.data.tblAreaManagement
          if(res.data.tblAreaManagement.userType === 2){
            this.dialogForm.xhid = res.data.tblAreaManagement.xhid ? Number(res.data.tblAreaManagement.xhid) : ''
          }
          this.getTblSplbDalei()
          this.treeForeach(res.data.areaManagementChildVOS, (node) => {
            if (!node.areaManagementChildVOS){
              this.checkedKeys.push(node.keyStr)
            }
          })
          console.log(this.checkedKeys)
          this.$refs.tree.setCheckedKeys(this.checkedKeys);
        }
      })
    },
    getManagementOptions () {
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/page'
      return this.HttpService.post(url,{pageNum:1,pageSize:999}).then(res => {
        if (res.statusCode === 200) {
          this.managementOptions = res.data.records
        }
      })
    },
    updateDynamicRules(userType) {
      if (userType === 1) {
        this.rules.partnerId = [{ required: false, message: '请选择合作方名称', trigger: 'change' }];
      } else {
        this.rules.partnerId = [{ required: true, message: '请选择合作方名称', trigger: 'change' }];
      }
    },
    userTypeChangeFun(){
      this.dialogForm.spid = ''
      this.dialogForm.xlid = '';
      this.dialogForm.xhid = '';
      this.getTblSplbDalei()
    },
    handleSpidChange() {
      this.dialogForm.xlid = '';
      this.dialogForm.xhid = '';
      this.$refs.ruleForm.clearValidate(['xlid', 'xhid']); // 清除校验状态
      this.getSpXiaolei();
    }
  },
  async mounted() {
    // await this.getTblSplbDalei();
    await this.getManagementOptions();
    this.loadAddressList();
    this.updateDynamicRules(this.dialogForm.userType); // 初始化时设置规则
  }
}
</script>
<style lang="scss" scoped>
.dialog {

  .dialog-footer {
    padding: 20px 60px;
  }
}

.tree {
  max-height: 200px;
  overflow: auto;
  border-radius: 3px;
  border: 1px solid #C0C4CC;
}
</style>



// WEBPACK FOOTER //
// src/views/recoveryManagement/component/editArea.vue